import React from 'react';
import {Col, Container, Nav, Navbar, Row} from "react-bootstrap";
import { Github, Twitter } from 'react-bootstrap-icons';

const NavBottom = () =>{
    return (
        <Navbar fixed="bottom" className="navbar navbar-dark position-sticky color-nav flex-md-nowrap p-0 shadow">
            <Container fluid>
                <Row>
                    <Col>
                        <div className="App-description">
                        <img src="./logo.png" height="65" alt=""/> Copyright &#169; 2021 - Metaframe&trade; - MTF&trade;
                        </div>
                    </Col>
                </Row>

            </Container>
            <Container>
                <Nav className="justify-content-end" activeKey="/">
                    <Nav.Item>
                        <Nav.Link href="#"><Github/></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="#"><Twitter/></Nav.Link>
                    </Nav.Item>
                </Nav>
            </Container>
        </Navbar>
    );
}
export default NavBottom;